<template>
  <tela-component title="Relatório Clientes sem Movimentação">
    <v-card flat rounded="lg">
      <v-card-text>
        <v-text-field
          label="Clientes sem movimentação há mais de"
          suffix="dias"
          v-model="filtro.dias_sem_movimentacao"
        ></v-text-field>

        <v-btn rounded block color="info" depressed @click="gerarRelatorio()"
          >Gerar Relatório</v-btn
        >
      </v-card-text>
    </v-card>
  </tela-component>
</template>

<script>
import { mapState } from "vuex";
import TelaComponent from "../tela/TelaComponent.vue";
export default {
  components: { TelaComponent },
  computed: mapState("usuario", ["usuarioLogado"]),
  data: () => ({
    filtro: {
      dias_sem_movimentacao: 0,
    },
  }),
  methods: {
    gerarRelatorio() {
      window.open(
        `${process.env.VUE_APP_BASE_URL}/nutricao-animal/relatorios/clientes-sem-movimentacao?token=${this.usuarioLogado.token}
        &dias=${this.filtro.dias_sem_movimentacao}`,
        "_blank"
      );
    },
  },
};
</script>

<style>
</style>